import * as React from "react";

var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgPr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-pr",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-37.3 0h682.7v512H-37.3z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(35) scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed0000",
    d: "M-37.3 0h768v512h-768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-37.3 102.4h768v102.4h-768zm0 204.8h768v102.4h-768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0050f0",
    d: "m-37.3 0 440.7 255.7L-37.3 511V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M156.4 325.5 109 290l-47.2 35.8 17.6-58.1-47.2-36 58.3-.4 18.1-58 18.5 57.8 58.3.1-46.9 36.3 18 58z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr);
export default ForwardRef;
export { ForwardRef as ReactComponent };